/*global SunergoPlatform*/

/**
 * Initialize Switch Button field.
 * @param {object} form 
 * @returns 
 */
const initFieldSwitch = function(form) {
	const actionName = 'form-field-switch';
	const switchFields = form.element.querySelectorAll(`[data-action="${actionName}"]`);
	if (!switchFields || switchFields.length < 1) return;

	SunergoPlatform.actionButtons.addAction(function(action, button) {
		if (action !== actionName) return false;

		const input = button.parentElement.querySelector('[data-form-field-switch-output]');
		input.value = button.getAttribute('aria-checked') == 'true' ? button.dataset.switchValueOn : button.dataset.switchValueOff;
		input.dispatchEvent(new Event('input'));
	});
};

export default initFieldSwitch;